// extracted by mini-css-extract-plugin
export var deleteIcon = "_td-5";
export var deleteOption = "_td-3";
export var divider = "_td-2";
export var downloadIcon = "_td-4";
export var drawer = "_td-0";
export var drawerFooter = "_td-6";
export var drawerOpen = "_td-1";
export var highlighted = "_td-7";
export var lighterHighlight = "_td-8";